import httpClient from '@/http-client'

export const getProfile = (Options = {}) => {
  return httpClient
    .get('/api/home/parent-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changePassword = data => {
  return httpClient
    .post('/api/home/parent-change-passwords', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/parent-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTotalMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/parent-get-total-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApproveTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/parent/approve-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPaymentHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/parent/get-payment-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/parent/get-notification-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/parent/notification-types', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getProfile,
  changePassword,
  getMyRequest,
  getTotalMyRequest,
  getApproveTypes,
  getPaymentHistory,
  getNotificationHistory,
  getNotificationTypes
}
